import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ApiDataService } from '../../services/api.service';
import { ToastrService } from 'ngx-toastr';
import { SharedModule } from '../../shared/shared.module';
import * as CryptoJS from 'crypto-js';

@Component({
    selector: 'app-change-password',
    imports: [FormsModule, SharedModule],
    templateUrl: './change-password.component.html',
    styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent implements OnInit  {
  password: string = '';
  rePassword: string = '';
  isValidPass: boolean = true;
  passMatched: boolean = true;
  isLinkExpired: boolean = false;
  userEmail: string = '';
  loader: boolean = false;
  transactionId: string = '';
  
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _apiService: ApiDataService,
    private toastr: ToastrService
  ){}

  ngOnInit(): void {
    this.validateUrl();
  }

  validateUrl(){
    this.loader = true;
    this.transactionId = this.route.snapshot.queryParams["transactionId"];
    this._apiService.validateUrl(this.transactionId).subscribe(x => {
      this.isLinkExpired = x.status;
      this.userEmail = x.email;
      this.loader = false;
    }, (error) => {
      this.loader = false;
    }, () => {
      this.loader = false;
    });
  }


 


  validatePassword(str: string){
    const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?=.*\d)[a-zA-Z0-9!@#$%^&*()~¥=_+}{":;'?/>.<,`\-\|\[\]]{6,50}$/
    re.test(str)? this.isValidPass = true : this.isValidPass = false;
    this.comparePassword();
  }

  comparePassword(){
    this.passMatched = this.rePassword === this.password;
  }
  
  setPassword(){
    const PAYLOAD = {
      email: this.userEmail? this.userEmail : null,
      userName: this.userEmail? null : this.transactionId,
      password: this.password,
      transactionId: this.transactionId
    };
    this._apiService.changePassword(PAYLOAD).subscribe(x => {
      if(x.status === 'Link expired please try again.'){
        this.toastr.error(x.status, 'Failed', {
          timeOut: 3000,
        });
      }
      // else if(x.status = ){

      // }
      else{
        this.toastr.success('Password Changed', 'Success', {
          timeOut: 3000,
        });
        setTimeout(() => {
          this.router.navigate(["/login"]);
        }, 1000);
      }
      
    }, (error) => {
      this.toastr.error(error.error.message, 'Failed', {
        timeOut: 3000,
      });
    }, () => {});
  }
  
}
